import { classnames } from "@culturehq/components";
import React from "react";

import styles from "./progress-line.module.scss";

type ProgressLineProps = {
  className?: string;
  color: string;
  valueNow: number;
  valueMax: number;
};

const ProgressLine: React.FC<ProgressLineProps> = ({ className, color, valueNow, valueMax }) => {
  const style = {
    backgroundColor: color,
    width: `${(valueNow / valueMax) * 100}%`
  };

  return (
    <div
      className={classnames(styles.line, className)}
      role="progressbar"
      aria-valuenow={valueNow}
      aria-valuemin={0}
      aria-valuemax={valueMax}
    >
      <div className="progressbar-bar" style={style} />
    </div>
  );
};

export default ProgressLine;
